import Spinner from "../../../components/Spinner/Spinner";
import EditIcon from "@mui/icons-material/Edit";
import Buttons from "../../../components/Buttons/Buttons";
import AcquisitionSettingsFields from "../Patient/AcquisitionSettingsFields";
import AcquisitionSettingsInfo from "../Patient/AcquisitionSettingsInfo";

const AcquisitionSettingsTab = ({
  isEditingAcquisition,
  setIsEditingAcquisition,
  patientFormProps,
}) => {
  return (
    <div className="tab-panel-content patientdetails">
      {patientFormProps.isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      {isEditingAcquisition ? (
        <>
          <div className="tab-panel-header">
            <h3>Edit Data Settings</h3>
          </div>
          <div className="acquisition-settings-sections">
            <AcquisitionSettingsFields
              formData={patientFormProps.formData}
              onChange={patientFormProps.handleChange}
              onCheckboxChange={patientFormProps.handleCheckboxChange}
              showDivider={false}
              sectioned
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "30px",
              borderTop: "1px solid #eee",
              paddingTop: "20px",
            }}
          >
            <Buttons
              text="Cancel"
              type="button"
              onClick={() => {
                patientFormProps.resetForm();
                setIsEditingAcquisition(false);
              }}
              variant="secondary"
              style={{ width: "100px" }}
            />
            <Buttons
              text="Save"
              type="button"
              onClick={() =>
                patientFormProps.handleSubmit(
                  () => setIsEditingAcquisition(false),
                  "acquisition",
                )
              }
              variant="primary"
              style={{ width: "100px" }}
            />
          </div>
        </>
      ) : (
        <>
          <div className="tab-panel-header">
            <h3>Data Settings</h3>
            <Buttons
              text="Edit"
              type="button"
              variant="primary"
              fullWidth={false}
              icon={<EditIcon fontSize="small" />}
              onClick={() => setIsEditingAcquisition(true)}
            />
          </div>
          <div className="patient-info-grid">
            <AcquisitionSettingsInfo
              formData={patientFormProps.formData}
              showDivider={false}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AcquisitionSettingsTab;
